import React from "react";
import { Button as MantineButton } from "@mantine/core";

enum COLORS {
  DEFAULT = "#3C61E3",
  VALIDATION = "#2f9e44",
}

export interface ButtonProps {
  variant?: "outline" | "disabled" | "validation";
  size?: "xs" | "sm" | "md" | "lg";
  children: React.ReactNode;
  onClick?: () => void;
  color?: string;
  dataTestId?: string;
}

export const Button = ({ ...props }: ButtonProps) => {
  const variant =
    props.variant && props.variant !== "validation" ? props.variant : "filled";
  const size = props.size ?? "md";
  const color =
    props.variant === "validation"
      ? COLORS.VALIDATION
      : (props.color ?? COLORS.DEFAULT);
  return (
    <MantineButton
      variant={variant}
      style={
        variant === "outline"
          ? {
              borderWidth: "2px",
            }
          : {}
      }
      size={size}
      color={color}
      onClick={props.onClick}
      disabled={variant === "disabled"}
      data-testid={props.dataTestId}
    >
      {props.children}
    </MantineButton>
  );
};
